import React from 'react'
import { Timeline as AntTimeline } from 'antd'
import {
  TimelineProps as AntTimelineProps,
  TimelineItemProps as AntTimeLineItemProps
} from 'antd/lib/timeline'

type Props = AntTimelineProps

const { Item: AntTimelineItem } = AntTimeline

export const Timeline: React.FC<Props> = ({ reverse, children, mode }) => (
  <AntTimeline mode={mode} reverse={reverse}>
    {children}
  </AntTimeline>
)

export const TimelineItem: React.FC<AntTimeLineItemProps> = ({
  children,
  color,
  position,
  ...props
}) => (
  <AntTimelineItem position={position} color={color} {...props}>
    {children}
  </AntTimelineItem>
)
